import { type FC } from 'react'
import { type UseFormReturn } from 'react-hook-form'

import { type MarketplacePartnerRegisterPageFormV3Values } from '../../hooks/marketplacePartnerRegisterPageFormV3RHFModel'
import { resolveOptions } from '../../hooks/marketplacePartnerRegisterPageFormV3Shared'
import { useMarketplacePartnerRegisterPageFormV3DictionaryOptions } from '../../hooks/useMarketplacePartnerRegisterPageFormV3DictionaryOptions'

import { MarketplacePartnerRegisterPageFormV3BasicInformations } from './MarketplacePartnerRegisterPageFormV3/MarketplacePartnerRegisterPageFormV3BasicInformations'
import { MarketplacePartnerRegisterPageFormV3BusinessDetails } from './MarketplacePartnerRegisterPageFormV3/MarketplacePartnerRegisterPageFormV3BusinessDetails'
import { MarketplacePartnerRegisterPageFormV3Categories } from './MarketplacePartnerRegisterPageFormV3/MarketplacePartnerRegisterPageFormV3Categories'
import { MarketplacePartnerRegisterPageFormV3CustomMessage } from './MarketplacePartnerRegisterPageFormV3/MarketplacePartnerRegisterPageFormV3CustomMessage'
import { MarketplacePartnerRegisterPageFormV3Marketing } from './MarketplacePartnerRegisterPageFormV3/MarketplacePartnerRegisterPageFormV3Marketing'

type MarketplacePartnerRegisterPageFormV3Props = {
  form: UseFormReturn<MarketplacePartnerRegisterPageFormV3Values>
}

export const MarketplacePartnerRegisterPageFormV3: FC<
  MarketplacePartnerRegisterPageFormV3Props
> = ({ form }) => {
  const {
    accountTypeOptions,
    annualRevenueOptions,
    categoriesOptions,
    countryCodeOptions,
    marketReadinessOptions,
    revenueExpectedOptions,
    targetCountriesOptions,
  } = useMarketplacePartnerRegisterPageFormV3DictionaryOptions()

  return (
    <div className="flex flex-col gap-20">
      <MarketplacePartnerRegisterPageFormV3BasicInformations
        countryCodeOptions={resolveOptions(countryCodeOptions)}
        form={form}
      />
      <MarketplacePartnerRegisterPageFormV3Categories
        categoriesOptions={resolveOptions(categoriesOptions)}
        form={form}
        targetCountriesOptions={resolveOptions(targetCountriesOptions)}
      />
      <MarketplacePartnerRegisterPageFormV3BusinessDetails
        accountTypeOptions={resolveOptions(accountTypeOptions)}
        annualRevenueOptions={resolveOptions(annualRevenueOptions)}
        form={form}
        marketReadinessOptions={resolveOptions(marketReadinessOptions)}
        revenueExpectedOptions={resolveOptions(revenueExpectedOptions)}
      />
      <MarketplacePartnerRegisterPageFormV3Marketing form={form} />
      <MarketplacePartnerRegisterPageFormV3CustomMessage form={form} />
    </div>
  )
}
